import React from "react";
import { companyInfo } from "../../data/general";

export interface Negotiator {
  name: string;
  email: string;
}

const DEFAULT_NEGOTIATOR: Negotiator = {
  name: "Letting Engine Team",
  email: companyInfo.email,
};

/** Postcode district prefix → assigned negotiator. Longest prefix match wins. */
const NEGOTIATOR_BY_PREFIX: Record<string, Negotiator> = {
  W1: { name: "Sarah Chen", email: "sarah.chen@lettingengine.com" },
  SW1: { name: "James Morrison", email: "james.morrison@lettingengine.com" },
  SW3: { name: "James Morrison", email: "james.morrison@lettingengine.com" },
  SW7: { name: "James Morrison", email: "james.morrison@lettingengine.com" },
  E1: { name: "Elena Vasquez", email: "elena.vasquez@lettingengine.com" },
  E14: { name: "Elena Vasquez", email: "elena.vasquez@lettingengine.com" },
  EC: { name: "Elena Vasquez", email: "elena.vasquez@lettingengine.com" },
  W2: { name: "David Okonkwo", email: "david.okonkwo@lettingengine.com" },
  NW1: { name: "David Okonkwo", email: "david.okonkwo@lettingengine.com" },
};

function extractPostcodePrefix(postcode: string): string {
  const normalized = postcode.trim().toUpperCase().replace(/\s+/g, "");
  const match = normalized.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)/);
  return match?.[1] ?? "";
}

export function getNegotiatorForPostcode(postcode: string): Negotiator {
  const prefix = extractPostcodePrefix(postcode);
  if (!prefix) return DEFAULT_NEGOTIATOR;

  const prefixes = Object.keys(NEGOTIATOR_BY_PREFIX).sort(
    (a, b) => b.length - a.length
  );

  for (const key of prefixes) {
    if (prefix.startsWith(key)) {
      return NEGOTIATOR_BY_PREFIX[key];
    }
  }

  return DEFAULT_NEGOTIATOR;
}

interface PropertyNegotiatorProps {
  postcode: string;
}

const PropertyNegotiator: React.FC<PropertyNegotiatorProps> = ({ postcode }) => {
  const negotiator = getNegotiatorForPostcode(postcode);

  return (
    <div className="mt-6 pt-6 border-t border-t-solid border-t-[rgba(0,0,0,0.05)]">
      <span className="font-manrope text-xs uppercase tracking-wider text-text-slate block mb-2">
        Your Property Negotiator
      </span>
      <div className="font-teko text-2xl text-text-obsidian leading-tight mb-1">
        {negotiator.name}
      </div>
      <a
        href={`mailto:${negotiator.email}`}
        className="font-manrope text-sm text-text-slate hover:text-brand-yellow transition-colors"
      >
        {negotiator.email}
      </a>
    </div>
  );
};

export default PropertyNegotiator;
